import { Reveal, SectionHead } from "./Reveal";

const POINTS = [
  { num: "01", t: "Sit in on real shoots", d: "Stand next to senior directors on live sets — not watching a recording of one." },
  { num: "02", t: "Handle client revisions", d: "Take actual notes from actual clients and learn to ship v2 better, faster." },
  { num: "03", t: "Earn commercial credits", d: "Leave with your name on delivered work you can point to in every interview." },
];

export const Experience = () => (
  <section data-testid="internship-experience-section" className="bg-ink border-y border-line py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="11" eyebrow="Inside The Agency" title="Agency / Internship Experience" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5 group">
          <div className="relative overflow-hidden border border-line">
            <img
              src="https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Behind the scenes on a commercial shoot"
              className="img-cine w-full h-[400px] sm:h-[520px] object-cover"
            />
            <span className="absolute top-5 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-acid bg-obsidian/70 backdrop-blur-sm px-3 py-2">
              On Set — Live Production
            </span>
          </div>
        </Reveal>

        <div className="lg:col-span-7 space-y-px bg-line border border-line">
          {POINTS.map((p, i) => (
            <Reveal key={p.num} delay={i * 0.1} className="bg-obsidian p-8 sm:p-10 flex gap-6">
              <span className="font-display font-extrabold text-4xl sm:text-5xl text-acid shrink-0">{p.num}</span>
              <div>
                <h3 className="font-head text-xl sm:text-2xl font-bold uppercase tracking-tight text-cream">{p.t}</h3>
                <p className="mt-2 text-sm sm:text-base text-smoke leading-relaxed">{p.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
